export default "/static/images/foundation_1.png?0e10c1c8900ea05997427b6bda0e2715";